var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinIconSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-size",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8888_32107)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-svg",
    d: "M9.73008 7.65096L13.0001 5.54096C13.1274 5.46371 13.2359 5.35898 13.3177 5.23443C13.3994 5.10987 13.4522 4.96863 13.4723 4.82104C13.4925 4.67344 13.4794 4.52321 13.434 4.38133C13.3886 4.23944 13.3121 4.10949 13.2101 4.00096L10.0001 0.790957C9.89155 0.688923 9.76159 0.612424 9.61971 0.56705C9.47782 0.521676 9.3276 0.508574 9.18 0.528701C9.0324 0.548828 8.89117 0.601675 8.76661 0.683382C8.64205 0.765088 8.53733 0.873589 8.46008 1.00096L6.30008 4.23096L1.81008 5.23096C1.7074 5.25587 1.61312 5.30746 1.53678 5.3805C1.46044 5.45354 1.40473 5.54545 1.37531 5.64692C1.34588 5.7484 1.34377 5.85585 1.36919 5.9584C1.39461 6.06095 1.44666 6.15498 1.52008 6.23096L7.67008 12.391C7.74793 12.4614 7.84264 12.5106 7.94505 12.5337C8.04746 12.5568 8.15411 12.5531 8.25468 12.5229C8.35524 12.4928 8.44631 12.4372 8.51909 12.3615C8.59186 12.2858 8.64387 12.1926 8.67008 12.091L9.73008 7.65096Z",
    stroke: "#4D4745",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-svg",
    d: "M4.59 9.38086L0.5 13.5009",
    stroke: "#312F2E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    className: "icon-svg",
    id: "clip0_8888_32107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIconSmall);
export default __webpack_public_path__ + "static/media/PinIconSmall.caa4576441091481050f5ddca17fc465.svg";
export { ForwardRef as ReactComponent };